<template>
  <div class="banner ease-605">
    <NavigationBar />
    <div class="banner-content">
     <router-link to="/"><img class="ease-logo" src="@/assets/ease-hospitality-logo.svg" alt="605 Third Ave New York, NY"/></router-link>
      <h1 data-aos="fade-in">
        605 3rd Avenue
      </h1>
      <p>New York</p>
    </div>
    <div class="scroll-to-bottom-container">
      <!--       <img src="@/assets/down-arrow.svg" /> -->
      <a class="txt-link left-link" v-b-modal.rfp-modal>
        <button class="location-button">Book Now</button>
      </a>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/banner.scss';
.banner.meetings-and-events-spaces{
  .banner-content{
    h1{
      font-weight: normal !important;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
export default {
  name: 'MeetingsBanner',
  components: {
    NavigationBar,
  }
}
</script>
